import "bootstrap/dist/css/bootstrap.min.css";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Dashboard from "./pages/Dashboard";
import SignIn from "./pages/SignIn";
import { isTokenExpired } from "./utils/authUtils";
import Outgoing from "./pages/Outgoing"
import Incoming from "./pages/Incoming";
import Report from "./pages/Report";
import Supplier from "./pages/Supplier";
import Coater from "./pages/Coater";
import { toast } from "sonner";
import Site from "./pages/Site";

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && isTokenExpired(token)) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      toast.error("Session expired. Please sign in again.");
      navigate("/signin");
    }
  }, [navigate]);

  const isAuthenticated = !!localStorage.getItem("token");

  return (
    <Routes>
      <Route
        path="/"
        element={isAuthenticated ? <Dashboard /> : <Navigate to="/signin" />}
      />
      <Route
        path="/outgoing"
        element={isAuthenticated ? <Outgoing /> : <Navigate to="/signin" />}
      />
      <Route
        path="/incoming"
        element={isAuthenticated ? <Incoming /> : <Navigate to="/signin" />}
      />
      <Route
        path="/report"
        element={isAuthenticated ? <Report /> : <Navigate to="/signin" />}
      />
      
      <Route
        path="/suppliers"
        element={isAuthenticated ? <Supplier /> : <Navigate to="/signin" />}
      />
      <Route
        path="/coaters"
        element={isAuthenticated ? <Coater /> : <Navigate to="/signin" />}
      />
      <Route
        path="/sites"
        element={isAuthenticated ? <Site /> : <Navigate to="/signin" />}
      />
      <Route path="/signin" element={<SignIn />} />
    </Routes>
  );
}

export default App;
